import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API_ENDPOINTS from "../../config/config";
import axios from "axios";
import "./ForgotPassword.css";

const BASE_URL = API_ENDPOINTS.BASE;

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [token, setToken] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract token from URL parameters
    const params = new URLSearchParams(location.search);
    const resetToken = params.get("token");
    if (!resetToken) {
      setError("Invalid reset link. Please request a new password reset.");
      return;
    }
    setToken(resetToken);
  }, [location]);

  const validatePasswords = () => {
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters long");
      return false;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePasswords()) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${BASE_URL}/forgot-password.php`, {
        token: token,
        newPassword: newPassword,
      });

      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setError(response.data.error || "Failed to reset password");
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "An error occurred while resetting your password"
      );
    } finally {
      setLoading(false);
    }
  };

  if (!token && error) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="forgot-password-container">
          <img 
            src="/fantasy.jpeg" 
            alt="Fantasy Packaging Private Limited" 
            className="forgot-password-logo"
          />
          <h2 className="forgot-password-title">Invalid Reset Link</h2>
          <p className="forgot-password-subtitle">{error}</p>
          <button
            onClick={() => navigate("/forgot-password")}
            className="forgot-password-button"
          >
            Request New Reset Link
          </button>
          <a href="/login" className="back-to-login">
            ← Back to Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="forgot-password-container">
        <img 
          src="/fantasy.jpeg" 
          alt="Fantasy Packaging Private Limited" 
          className="forgot-password-logo"
        />
        <h2 className="forgot-password-title">Reset Your Password</h2>
        <p className="forgot-password-subtitle">
          Enter your new password below
        </p>

        {error && (
          <div className="error-message" role="alert">
            {error}
          </div>
        )}

        {success ? (
          <div className="step-content">
            <div className="success-message">
              Password reset successful! Redirecting to login...
            </div>
            <div className="success-title">
              Success!
            </div>
            <p>You can now log in with your new password.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px', color: '#374151' }}>
                New Password
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="forgot-password-input"
                placeholder="Enter new password (min. 8 characters)"
                required
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px', color: '#374151' }}>
                Confirm Password
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="forgot-password-input"
                placeholder="Confirm new password"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="forgot-password-button"
            >
              {loading ? "Resetting Password..." : "Reset Password"}
            </button>
          </form>
        )}

        <a href="/login" className="back-to-login">
          ← Back to Login
        </a>
      </div>
    </div>
  );
};

export default ResetPassword;
